import ExaminerCheatSheet from './ExaminerCheatSheet';

const config = {
  subjectKey: 'maths',

  path: '/gcse-maths-examiner-tips',

  crumbLabel: 'GCSE Maths Examiner Tips',

  appHubPath: '/gcse-maths-revision',

  appHubLabel: 'GCSE Maths revision',

  seoTitle: 'GCSE Maths Examiner Tips Cheat Sheet | Free Printable Guide',

  seoDescription:
    'Free printable GCSE Maths examiner tips cheat sheet. Learn why marks are lost, what examiners look for, common mistakes and Grade 9 moves across algebra, quadratics, graphs, trigonometry, percentages and probability.',

  h1: 'GCSE Maths Examiner Tips — what separates Grade 6 from Grade 9',

  heroLede:
    'Print this once and keep it beside your revision notes. Every key GCSE Maths topic — from factorising, quadratics and completing the square to straight-line graphs, trigonometry, percentages and tree diagrams — is broken into four simple blocks: why marks are lost, what examiners want, common traps and the Grade 9 move.',

  related: [
    {
      href: '/gcse-maths-revision',
      testid: 'maths-hub',
      kicker: 'Subject hub',
      title: 'Full GCSE Maths revision guide',
    },
    {
      href: '/gcse-english-examiner-tips',
      testid: 'english-tips',
      kicker: 'Cheat sheet',
      title: 'GCSE English Examiner Tips',
    },
    {
      href: '/gcse-science-examiner-tips',
      testid: 'science-tips',
      kicker: 'Cheat sheet',
      title: 'GCSE Science Examiner Tips',
    },
    {
      href: '/gcse-grade-boundaries-calculator',
      testid: 'grade-calc',
      kicker: 'Free tool',
      title: 'GCSE Grade Boundaries Calculator',
    },
  ],
};

export default function GCSEMathsExaminerTips() {
  return <ExaminerCheatSheet config={config} />;
}